import React, { Component } from "react";
import Header from "./parts/Header";
import Menu from "./parts/Menu";
import multilanguage from '../multilanguage';
import api from '../api/api';
import auth from '../api/auth';
import moment from 'moment';
import DLoader from "./parts/DLoader";
import { isEmpty } from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';

class DOrders extends Component {
  state = {
    loading: true,
    loadingStatistics: true,
    requests: [],
    search: '',
    selectedPage: 1,
    infinitePcrollPage: 1,
    items: [],
    hasMore: true,
  };
componentDidMount(){
  if(this.props.location.state){
    this.doSearch(this.props.location.state.pesel, 1)
  }else{
  this.doSearch('')
  }
  this.changeMonthStatistics(moment().format('YYYY-MM'));
}
searchtimeout = null
  doSearch(search){
    if(this.state.value == search)
    this.setState({loading: true})
    else
    this.setState({loading: true, items: [], infinitePcrollPage: 1, value: search})
    api.get('/ServiceRequest', {searchQuery: search, page: this.state.infinitePcrollPage})
            .then(res => {
              //console.log(res);
              var numberOfPages = res.data.totalResults/res.data.pageSize
                    if(Number.isInteger(numberOfPages)){
                        this.setState({
                          loading: false,
                          items: this.state.items.concat(res.data.results),
                          numberOfPages : numberOfPages,
                        })
                    }else{
                        numberOfPages = Math.floor(numberOfPages)+1
                        this.setState({
                          loading: false,
                          items: this.state.items.concat(res.data.results),
                          numberOfPages : numberOfPages,
                        })
                    }
                    if(this.state.infinitePcrollPage < numberOfPages){
                      this.setState({infinitePcrollPage: this.state.infinitePcrollPage+1})
                  }else{
                      this.setState({hasMore: false})
                  }
              
            })
  }
  search(search){
    this.setState({items: [], value: search, infinitePcrollPage: 1})
    if (this.searchtimeout) clearTimeout(this.searchtimeout)
    this.searchtimeout = setTimeout(() => this.doSearch(search), 1000);
  }

  changeMonthStatistics(month) {
    this.setState({loadingStatistics: true})
    api.get('/Statistics/ServiceRequest', {month: month})
    .then(res => {
        this.setState({loadingStatistics: false, monthStatistic: res.data})
    });
  }
  
  render() {
    return (
      <div className="desktop_container">
        <Menu screenProps={this.props.history} />
        <div className="desktop_container_content">
          <Header screenProps={this.props.history} />
          <div className="d_main_content">
          {this.state.monthStatistic != null && auth.auth.user.role == 'practitioner'?
                        <div className="d_packages_info_container">
                            <svg width="36" height="93" viewBox="0 0 36 93" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="noun_Info_73316">
                                <path id="Shape" fillRule="evenodd" clipRule="evenodd" d="M36 11.0174C36 14.0567 34.831 16.6482 32.4916 18.7827C30.1528 20.917 27.3431 21.988 24.0496 21.988C20.7691 21.988 17.9326 20.917 15.58 18.7827C13.2412 16.6482 12.0584 14.0567 12.0584 11.0174C12.0584 7.98328 13.2412 5.3927 15.58 3.23864C17.9326 1.08386 20.7691 0 24.0496 0C27.3431 0 30.1528 1.08386 32.4916 3.23864C34.831 5.3927 36 7.98328 36 11.0174ZM31.3624 82.9082C33.5539 84.5734 31.322 88.2144 27.1009 90.1514C23.4444 91.844 18.9277 93 15.7686 93C10.9025 93 6.74856 90.8255 4.04592 88.479C1.344 86.1394 0 83.1794 0 79.5905C0 78.1891 0.09408 76.7613 0.29556 75.3003C0.51036 73.8404 0.83364 72.1947 1.2636 70.3573L6.30492 52.87C6.762 51.1981 7.12428 49.6056 7.43364 48.1115C7.72956 46.6185 7.90416 45.2367 7.90416 44.0076C7.90416 41.7671 7.42044 40.2141 6.4794 39.3417C5.53824 38.4622 3.76368 38.0203 1.11552 38.0203C-0.18816 38.0203 -1.49232 32.9965 4.3824 30.9745C7.38012 29.9568 10.2433 29.5668 12.9318 29.5668C17.7713 29.5668 21.5084 30.7243 24.1165 33.0168C26.738 35.3169 28.0558 38.304 28.0558 41.9716C28.0558 42.7253 27.9612 44.0603 27.7865 45.9905C27.5986 47.9001 27.2488 49.6585 26.7784 51.2581L21.764 68.6792C21.3608 70.0799 20.9844 71.6865 20.6618 73.4833C20.3392 75.275 20.1913 76.6299 20.1913 77.5545C20.1913 79.8677 20.7022 81.4343 21.764 82.2802C22.8124 83.119 24.6412 83.5357 27.2356 83.5357C27.683 83.5357 28.1912 83.3186 28.718 83.0936C29.6152 82.7105 30.5662 82.3043 31.3624 82.9082Z" fill="#FDB913"/>
                                </g>
                            </svg>
                            <div className="d_statistics_detail_column_width">
                                <div className="d_statistics_detail_column_1_width">
                                    <div>Zobacz podsumowanie za miesiąc:</div>
                                    <div className="d_page_title_search_month_container">
                                      <input type="month"  
                                          value={this.state.monthStatistic.month}
                                          onChange={evt => this.changeMonthStatistics(evt.target.value)}/>
                                    </div>
                                </div>
                                {this.state.loadingStatistics ? 
                                <DLoader />
                                : null
                                }
                                <div className="d_statistics_detail_column_2_width">
                                  <div>Zlecenia zrealizowane (liczba / wartość)</div>
                                  <div className="d_statistics_detail_column_stat">{this.state.monthStatistic.activatedCount} / {this.state.monthStatistic.activatedPrice} zł</div>
                                </div>
                                <div className="d_statistics_detail_column_3_width">
                                  <div>Zlecenia niezrealizowane (liczba / wartość)</div>
                                  <div className="d_statistics_detail_column_stat">{this.state.monthStatistic.nonActivatedCount} / {this.state.monthStatistic.nonActivatedPrice} zł</div>
                                </div>
                            </div>
                        </div>
                        : null}
            <div className="d_page_title_container">
                <div className="d_page_title_with_button">
                    <div className="d_page_title">{multilanguage.orders_simple} </div>
                    <div className="d_add_patient_button" onClick={() => this.props.history.push('/library')}>
                        <img  src={require('../assets/images/desktop/plus.svg')} />
                        <span>{multilanguage.new_order}</span>
                    </div>
                </div>
              
              <div className="d_page_title_right_flex">
                {/* <div className="d_page_title_sort">
                  <span>{multilanguage.sort_by}: </span>
                  <select>
                    <option>{multilanguage.newest_simple}</option>
                    <option>{multilanguage.type_simple}</option>
                  </select>              
                </div> */}
                <div className="d_page_title_search_container">
                    <img src={require('../assets/images/desktop/search1.svg')} />
                      <input 
                      value={this.state.value}
                      onChange={evt => this.search(evt.target.value)}
                      disabled={this.state.loading}
                      type="text" />
                </div>
              </div>

            </div>
            <div className="">

                <div className="dpat_table_header">
                    <div className="dpath_nr">{multilanguage.order_no}.</div>
                    <div className="dpath_name">{multilanguage.patient}</div>     
                    <div className="dpath_date">{multilanguage.date_simple}</div>
                    <div className="dpath_order_status">Status</div>
                    <div className="dpath_price">{multilanguage.price_simple}</div>
                    <div className="dpath_services">{multilanguage.services}</div>
                </div>
                {this.state.loading && !this.state.hasMore ? <DLoader /> : null}
                <InfiniteScroll
                  dataLength={this.state.items.length} //This is important field to render the next data
                  next={() => {if(!this.state.loading) this.doSearch(this.state.value)}}
                  hasMore={this.state.hasMore}
                  scrollableTarget="index"
                  scrollThreshold= {0.9}
                  loader={<DLoader />}
                  children
                  >
                  {this.state.items.map((result)=>{
                      var numeservice = ''
                      var servicesPrice = 0;
                      result.services.map((service)=>{
                        numeservice=numeservice+service.name+", "
                        servicesPrice += service.basePrice;
                      });
                      var orderStatus = result.extraFields?.find(x => x.system == "Status")?.value;
                      return(
                        <div className="dpat_table_line">
                        <div className="dpath_nr_line_order" onClick={() => this.props.history.push('/order_detail/'+result.id)}>{result.id}</div>
                        {result.patient.id ? 
                          <div className="dpath_name_line" onClick={() => this.props.history.push('/patient_detail/'+result.patient.id)}>
                            {/* <img className="d_header_left_avatar" src={result.patient.gender == 'F' ? require('../assets/images/famale.png') : require('../assets/images/male.png')} /> */}
                            <span>{result.patient.firstName} {result.patient.lastName}</span>
                          </div>
                        : 
                        <div className="dpath_name_line" > 
                            {/* <img className="d_header_left_avatar" src={result.patient.gender == 'F' ? require('../assets/images/famale.png') : require('../assets/images/male.png')} /> */}
                            <span>{result.patient.firstName} {result.patient.lastName}</span>
                        </div>}
                        <div className="dpath_date_line">{moment(result.validFrom).format('DD.MM.YYYY')}</div>
                        <div className="dpath_order_status_line">
                          { orderStatus == "Completed" || orderStatus == "Active" ?
                            <div className="dpath_order_status_completed">Zrealizowane</div>
                            :
                            <div className="dpath_order_status_pending">Niezrealizowane</div>
                          }
                        </div>
                        <div className="dpath_price_line">{servicesPrice} {multilanguage.currency}</div>
                        <div className="dpath_city_line" onClick={() => this.props.history.push('/order_detail/'+result.id)}>{((numeservice).length > 60) ? (((numeservice).substring(0,60-3)) + '...') : numeservice}</div>
                        <div className="dpath_details bigger-space" onClick={() => this.props.history.push('/order_detail/'+result.id)}>
                            <div className="dpath_details_button dpath_details_buttons">{multilanguage.details_simple}</div>
                        </div>
                    </div>
                  
                      )
                  })}
                </InfiniteScroll>
                {/* {this.state.items.map((result)=>{
                  return(
                
                    <div className="dpat_table_line">
                        <div className="dpath_nr_line_order">{result.id}</div>
                        {result.patient.id ? 
                          <div className="dpath_name_line" onClick={() => this.props.history.push('/patient_detail/'+result.patient.id)}>
                            <img className="d_header_left_avatar" src={require('../assets/images/personPlaceholder.jpg')} />
                            <span>{result.patient.firstName} {result.patient.lastName}</span>
                          </div>
                        : 
                        <div className="dpath_name_line" > 
                            <img className="d_header_left_avatar" src={require('../assets/images/personPlaceholder.jpg')} />
                            <span>{result.patient.firstName} {result.patient.lastName}</span>
                        </div>}
                        <div className="dpath_email_line">{moment(result.validFrom).format('DD.MM.YYYY')}</div>
                        <div className="dpath_city_line">Bucharest</div>
                        <div className="dpath_location_line">{result.locationScope}</div>
                        <div className="dpath_details" onClick={() => this.props.history.push('/order_detail/'+result.id)}>
                            <div className="dpath_details_button">{multilanguage.details_simple}</div>
                        </div>
                    </div>
                  
                  )
                })} */}
                {/* {this.state.loading || isEmpty(this.state.requests) || this.state.numberOfPages <= 1 ? null :
                <div class="pagination">
                    <div className="d_store_menu_buttons" onClick={() => this.doSearch(this.state.value, this.state.selectedPage > 1 ?  this.state.selectedPage-1 : this.state.selectedPage)}>
                        <span>{multilanguage.previous_page}</span>
                    </div>
                    <div className="d_store_menu_buttons" onClick={() => this.doSearch(this.state.value, this.state.selectedPage < this.state.numberOfPages ?  this.state.selectedPage+1 : this.state.selectedPage)}>
                        <span>{multilanguage.next_page}</span>
                    </div> 
                </div> } */}

            </div>
          </div>
        </div>
      </div>
)}
}

export default DOrders;
